// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"9904453ea776c0a8873e","678":"86fc94d6a9feb0a99d59","883":"39aa4abd3f6cbb774a78"}[chunkId] + ".js";
};